import { ActionMenuList, ListItem, Tooltip } from '@ds';
import { DSDownloadIcon } from '@ds-icons';
import React from 'react';
import { getDownloadAssetURL } from '@/util/assetsApi';
import {
  getAssetPreviewConfig,
  isRemoteFile
} from '@experiment-management-shared/utils/assetsUtils';
import get from 'lodash/get';
import { InsertDriveFile } from '@mui/icons-material';
import { formatBytes } from '@/helpers/generalHelpers';
import { ArtifactVersionAsset } from '@artifacts/types/ArtifactVersionAsset';
import styles from './ArtifactVersionAssetsTable.module.scss';

export const renderActionsCell = (
  row: ArtifactVersionAsset,
  experimentKey: string,
  artifactVersionId: string
) => {
  const isRemote = isRemoteFile(row);
  const downloadURL = getDownloadAssetURL(
    experimentKey,
    row.assetId,
    artifactVersionId
  );
  const tooltipMessage = isRemote
    ? 'Remote synced artifacts are not downloadable through the Comet UI, please use the Comet SDK to download this artifact'
    : 'Download asset';

  return (
    <ActionMenuList>
      <ActionMenuList.Trigger />
      <ActionMenuList.Body>
        <Tooltip
          content={<div className={styles.tooltip}>{tooltipMessage}</div>}
          placement="top"
        >
          <a
            href={isRemote ? undefined : downloadURL}
            style={{
              pointerEvents: isRemote ? 'none' : 'auto'
            }}
          >
            <ListItem disabled={isRemote}>
              <ListItem.PrefixContainer>
                <ListItem.Icon Icon={<DSDownloadIcon />} />
              </ListItem.PrefixContainer>
              <ListItem.Text primary="Download" />
            </ListItem>
          </a>
        </Tooltip>
      </ActionMenuList.Body>
    </ActionMenuList>
  );
};

export const renderNameCell = (row: ArtifactVersionAsset) => {
  const Icon = get(
    getAssetPreviewConfig({
      fileName: row.fileName,
      fileSize: row.fileSize,
      link: row.link,
      type: row.type
    }),
    'Icon',
    InsertDriveFile
  );
  return (
    <div className={styles.fileNameContainer}>
      <Icon />
      {row.fileName}
    </div>
  );
};

export const renderSizeCell = (row: ArtifactVersionAsset) =>
  isRemoteFile(row) ? 'remote' : formatBytes(row.fileSize);
